// extracted by mini-css-extract-plugin
module.exports = {"pintxo-icon-blob-extended":"IconBlobExtended_pintxo-icon-blob-extended__K7jo7"};